import { render } from "./main-vedio.vue?vue&type=template&id=b6e8a27a"
import script from "./main-vedio.vue?vue&type=script&lang=js"
export * from "./main-vedio.vue?vue&type=script&lang=js"

import "./main-vedio.vue?vue&type=style&index=0&id=b6e8a27a&lang=less"

import exportComponent from "/Users/jiaxibei/Desktop/bilibiliProjects/ProfessProject/campus-activity-toc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__